import { useEffect } from 'react';

const LOGIN_INPUT_SELECTORS = [
  'input[aria-label="Remux server URL"]',
  'input[aria-label="Username"]',
  'input[aria-label="Password"]',
  'input[aria-label="Confirm password"]',
];
const LOGIN_INPUT_SELECTOR = LOGIN_INPUT_SELECTORS.join(',');
const LOGIN_AUTOFILL_SELECTOR = LOGIN_INPUT_SELECTORS.flatMap((selector) => [
  `${selector}:-webkit-autofill`,
  `${selector}:-webkit-autofill:hover`,
  `${selector}:-webkit-autofill:focus`,
]).join(',');

const LOGIN_INPUT_CSS =
  `${LOGIN_INPUT_SELECTOR}{-webkit-tap-highlight-color:transparent;caret-color:#fff}` +
  `${LOGIN_INPUT_SELECTOR}:focus{outline:none!important}` +
  `${LOGIN_AUTOFILL_SELECTOR}{` +
  `-webkit-text-fill-color:#fff!important;` +
  `-webkit-box-shadow:0 0 0 1000px #291f1f inset!important;` +
  `caret-color:#fff!important}`;

let loginInputStyleInjected = false;

/** Keep WebKit focus and autofill paint inside the designed dark input. */
export function useLoginInputPresentation(): void {
  useEffect(() => {
    if (loginInputStyleInjected) return;
    loginInputStyleInjected = true;
    const style = document.createElement('style');
    style.id = 'jellyflix-login-input-presentation';
    style.textContent = LOGIN_INPUT_CSS;
    document.head.appendChild(style);
  }, []);
}
